import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const MaTravelPackage = () => {
  const [maTravelPackage, setMaTravelPackage] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`maTravelPackage?page=${page}`);
      setMaTravelPackage(data.data);
      setLastPage(data.meta.last_page);
    })();
  }, [page]);
  const del = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      await axios.delete(`maTravelPackage/${id}`);
      setMaTravelPackage(
        maTravelPackage.filter((maTravelPackage) => maTravelPackage.id !== id),
      );
    }
  };
  return (
    <Wrapper pageTitle={"Travel Packages"}>
      <InnerNav
        createLink={"/maTravelPackageCreate"}
        listLink={"/maTravelPackage"}
      />
      <div className="w-full overflow-hidden rounded-lg shadow-xs">
        <div className="w-full overflow-x-auto">
          <table className="w-full whitespace-no-wrap">
            <thead>
              <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                <th className="px-4 py-3">#Ref </th>
                <th className="px-4 py-3">Name </th>
                <th className="px-4 py-3">Date Range </th>
                <th className="px-4 py-3">Total Cost </th>
                <th className="px-4 py-3">Action</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
              {maTravelPackage && maTravelPackage.length > 0 ? (
                maTravelPackage.map((maTravelPackage) => (
                  <tr
                    key={maTravelPackage.id}
                    className="text-gray-700 dark:text-gray-400"
                  >
                    <td className="px-4 py-5">{maTravelPackage.id}</td>
                    <td className="px-4 py-3 text-sm">
                      <Link
                        className="btn btn-sm btn-outline-secondary px-5"
                        to={`/maPackageDetails/${maTravelPackage.id}/details`}
                      >
                        {maTravelPackage.name}
                      </Link>
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {maTravelPackage.date_range}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {maTravelPackage.total_cost}
                    </td>
                    <td className="flex px-4 py-3 text-sm">
                      <Link
                        className="btn btn-sm btn-outline-secondary px-5"
                        to={`/maTravelPackage/${maTravelPackage.id}/edit`}
                      >
                        <AiFillEdit />{" "}
                      </Link>
                      <span
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => del(maTravelPackage.id)}
                      >
                        {" "}
                        <AiFillDelete className="text-rose-500 text-lg" />
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-5 text-gray-500">
                    No data to display{" "}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Paginator lastPage={lastPage} pageChanged={setPage} />
      </div>
    </Wrapper>
  );
};
export default MaTravelPackage;
